import clsx from 'clsx'

import { Link } from '@/ui-components/Link'

export const Text = ({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) => {
  return (
    <p
      data-slot="text"
      {...props}
      className={clsx(className, 'text-base/6 text-gray-500 sm:text-sm/6 dark:text-gray-400')}
    />
  )
}

export const TextLink = ({ className, ...props }: React.ComponentPropsWithoutRef<typeof Link>) => {
  return (
    <Link
      {...props}
      className={clsx(
        className,
        'text-gray-900 underline decoration-gray-900/50 data-hover:decoration-gray-900 dark:text-white dark:decoration-white/50 dark:data-hover:decoration-white',
      )}
    />
  )
}

export const Strong = ({ className, ...props }: React.ComponentPropsWithoutRef<'strong'>) => {
  return (
    <strong
      {...props}
      className={clsx(className, 'font-medium text-gray-900 dark:text-white')}
    />
  )
}

export const Code = ({ className, ...props }: React.ComponentPropsWithoutRef<'code'>) => {
  return (
    <code
      {...props}
      className={clsx(
        className,
        'rounded-sm border border-gray-900/10 bg-gray-900/[2.5%] px-0.5 text-sm font-medium text-gray-900 sm:text-[0.8125rem] dark:border-white/20 dark:bg-white/5 dark:text-white',
      )}
    />
  )
}
